<template>
    <el-dialog  title="我的面试安排" :visible.sync="showDialog">
        <div style="min-height: 300px;" v-if="tableData.length">
            <el-table :data="tableData">
                <el-table-column property="recordName" label="名称" width="300">
                    <template slot-scope="scope">
                        <router-link :to="'/arrangements/'+scope.row.rpIds">{{scope.row.recordName}}</router-link>
                    </template>
                </el-table-column>
                <el-table-column property="address" align="right" label="操作">
                    <template slot-scope="scope">
                        <el-button type="text" icon="el-icon-my-bianji"  @click="editName(scope.row, scope.$index)"></el-button>
                        <el-button type="text" icon="el-icon-my-shanchu color-danger" @click="removeRow(scope.row, scope.$index)"></el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                    class="text-center mt-20"
                    small
                    layout="total, prev, pager, next"
                    @current-change="pageIndexChange"
                    :current-page="~~page.pageIndex"
                    :page-size="~~page.pageSize"
                    :total="~~page.recordCounts">
            </el-pagination>
        </div>
    </el-dialog>
</template>
<style lang="scss" scoped>
    .el-pagination{
        .el-pagination__total{
            margin-top: -3px;
        }
    }
</style>
<script>
    import axios from 'axios'
    export default {
        data () {
            return {
                showDialog: false,
                page: null,
                tableData: [],
                pageIndex: 1
            }
        },
        watch: {
            pageIndex: function () {
                this.getList()
            }
        },
        methods: {
            show () {
                this.showDialog = true
            },
            editName (item) {
                this.$prompt('请输入面试安排记录名称', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    inputValue: item.recordName,
                    inputPattern: /^[\S]{1,20}$/,
                    inputErrorMessage: '不能为空，不能空字符开头，长度不能超过20'
                }).then(({ value }) => {
                    axios.post('/resumePosition/interviewRecord/update.api', {
                        recordName: value,
                        rpIds: item.rpIds,
                        id: item.id
                    }, {
                        'X-showMessage': true
                    }).then(res => {
                        this.getList()
                    }).catch(() => {})
                }).catch(() => {})
            },
            getList () {
                axios.get('/resumePosition/interviewRecord/list.api', {
                    params: {
                        pageSize: 10,
                        pageIndex: this.pageIndex
                    }
                }).then(res => {
                    this.tableData = res.result.list
                    this.page = res.page
                }).catch(() => {})
            },
            pageIndexChange (val) {
                this.pageIndex = val
            },
            removeRow (item) {
                this.$confirm('您确认删除该记录?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    axios.post('/resumePosition/interviewRecord/delete.api', {id: item.id}, {
                        'X-showMessage': true
                    }).then(res => {
                        this.getList()
                    }).catch(() => {})
                })
            }
        },
        created () {
            this.getList()
        }
    }
</script>


// WEBPACK FOOTER //
// myArrangementListDialog.vue?37ffc88e